export default "assets/images/botiella_white-54ef8f71.png";